import {Component, EventEmitter, Input, OnChanges, Output, SimpleChanges} from '@angular/core';

@Component({
    selector: 'app-textarea',
    templateUrl: './textarea.component.html',
    styleUrls: ['./textarea.component.scss']
})
export class TextareaComponent implements OnChanges {
    @Input() required: boolean;
    @Input() textValue: string;
    @Input() placeholder: string;
    @Output() emitInputEvent = new EventEmitter<string>();
    inputText = '';

    emitInputValue(): void {
        this.emitInputEvent.emit(this.inputText);
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.textValue) {
            this.inputText = this.textValue;
        }
    }
}
